import styled from 'styled-components';
import { ReactComponent as InfoRedIcon } from '@elementary/common-ui/assets/24x24/info-red.svg';
import { PageAlert } from '@elementary/common-ui/components';
import useAccount from '@elementary/common-ui/hooks/useAccount';
import useSupportChat from 'shared/hooks/useSupportChat';

const Link = styled.span`
  color: ${({ theme }) => theme.palette.common.blue4};
  text-decoration: underline;
  cursor: pointer;
`;

const AppPageAlert = () => {
  const { data: account } = useAccount();
  const supportChat = useSupportChat();

  if (account?.activation_status !== 'inactive') {
    return null;
  }

  return (
    <PageAlert icon={<InfoRedIcon />} severity="error">
      <b>Account is deactivated.</b> Your trial has expired, if you wish to keep
      using Elementary{' '}
      <Link onClick={supportChat.show}>please contact us here.</Link>
    </PageAlert>
  );
};

export default AppPageAlert;
